import React from 'react'
import styles from './CueTooltip.scss'
import { Popup } from 'common/Map/Popup'

// TODO cue icons
export class CueTooltip extends React.PureComponent {
  render () {
    const { coursePoint } = this.props
    return (
      <Popup
        closeButton={false}
        position={{ lat: coursePoint.y, lng: coursePoint.x }}
        maxWidth={200} minWidth={50}>
        <div className={styles.CueTooltip}>{coursePoint.n}</div>
      </Popup>
    )
  }
}
